import { CheckCircle2, Circle, Loader2 } from "lucide-react";
import NoDataState from "../../components/NoDataState";
import { Card, ProgressBar } from "./ui";

/** Error card with Retry — used whenever a mock service call fails (try ?demo=error). */
export function ErrorState({ error, onRetry, title = "Something went wrong" }) {
  return (
    <Card className="flex items-center justify-center">
      <NoDataState
        icon="alert"
        title={title}
        message={error?.message || "The request failed. Please try again."}
        showBack={false}
        showRefresh={!!onRetry}
        onRefresh={onRetry}
        size="small"
      />
    </Card>
  );
}

/**
 * Stage list + progress bar for a fake background job (parse / calculate).
 * `progress` comes from useBackgroundJob.
 */
export function JobProgress({ progress, stages, title }) {
  const list = progress?.stages || stages;
  const current = progress?.stageIndex ?? 0;
  const pct = progress?.pct ?? 2;
  return (
    <div className="flex flex-col gap-3" aria-live="polite">
      <div className="flex items-center justify-between text-[12.5px]">
        <span className="font-semibold text-text_primary">{title}</span>
        <span className="tabular-nums text-text_muted">{Math.round(pct)}%</span>
      </div>
      <ProgressBar pct={pct} />
      <ol className="flex flex-wrap items-center gap-x-1 gap-y-2">
        {list.map((s, i) => {
          const done = i < current;
          const active = i === current;
          return (
            <li key={s} className="flex items-center gap-1">
              <span className={`inline-flex items-center gap-1.5 text-[12px] ${done ? "text-success" : active ? "text-text_primary font-semibold" : "text-text_muted"}`}>
                {done ? (
                  <CheckCircle2 size={13} aria-hidden="true" />
                ) : active ? (
                  <Loader2 size={13} className="animate-spin" aria-hidden="true" />
                ) : (
                  <Circle size={13} aria-hidden="true" />
                )}
                {s}
              </span>
              {i < list.length - 1 && <span className="px-1 text-text_muted" aria-hidden="true">→</span>}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
